"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var module_components_1 = require("@empiriecom/module-components");
var useMeasure_1 = __importDefault(require("@empiriecom/module-components/hooks/useMeasure"));
var theme_1 = __importDefault(require("@empiriecom/module-components/theme"));
var getIcon_1 = __importDefault(require("@empiriecom/module-components/utils/getIcon"));
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_media_match_1 = require("react-media-match");
var react_spring_1 = require("react-spring");
var styled_components_1 = __importDefault(require("styled-components"));
var useConfig_1 = __importDefault(require("../../hooks/useConfig"));
var submitRegisterForm_1 = __importDefault(require("../HelperFunctions/submitRegisterForm"));
var newsletterSheetTextsPage1 = react_intl_1.defineMessages({
    emailPlaceholder: {
        id: 'nlSheet.emailPlaceholder',
        defaultMessage: '{content}',
    },
    generalInformationText: {
        id: 'nlSheet.genInfoText',
        defaultMessage: '{content}',
    },
    voucherCondition: {
        id: 'nlSheet.voucherCondition',
        defaultMessage: '{content}',
    },
});
/* this wrapper holds the form styles - the styles of a styled form would be dismissed on integration */
var StyledFormWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  form {\n    display: flex;\n    height: 2.75rem;\n    width: 100%;\n    flex-basis: 100%;\n    align-items: stretch;\n    margin-bottom: 0.5rem;\n    input {\n      flex-grow: 1;\n      align-self: stretch;\n      padding: 0.8rem 1rem;\n    }\n\n    button {\n      max-width: 18.5rem;\n    }\n\n    #newsletterEmail {\n      margin-right: 0.5rem;\n\n      ", "\n    }\n  }\n"], ["\n  form {\n    display: flex;\n    height: 2.75rem;\n    width: 100%;\n    flex-basis: 100%;\n    align-items: stretch;\n    margin-bottom: 0.5rem;\n    input {\n      flex-grow: 1;\n      align-self: stretch;\n      padding: 0.8rem 1rem;\n    }\n\n    button {\n      max-width: 18.5rem;\n    }\n\n    #newsletterEmail {\n      margin-right: 0.5rem;\n\n      ",
    "\n    }\n  }\n"])), function (_a) {
    var hasError = _a.hasError, error = _a.theme.error;
    return hasError && "border: 0.125rem solid " + error.color.normal + ";";
});
var StyledPageContent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.75rem;\n"], ["\n  font-size: 0.75rem;\n"])));
var ConditionHead = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  height: 1.5rem;\n  overflow: hidden;\n\n  svg {\n    transition: all 0.3s ease;\n    ", "\n  }\n"], ["\n  cursor: pointer;\n  height: 1.5rem;\n  overflow: hidden;\n\n  svg {\n    transition: all 0.3s ease;\n    ", "\n  }\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && 'transform: rotate(180deg);';
});
var ConditionBody = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0.5rem 0;\n  overflow: hidden;\n"], ["\n  margin: 0.5rem 0;\n  overflow: hidden;\n"])));
var StyledErrorMessage = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  font-weight: 500;\n  padding: 0.125rem 1rem 0.625rem 0;\n\n  svg {\n    width: 1rem;\n    height: 1rem;\n    margin-right: 0.125rem;\n  }\n"], ["\n  display: flex;\n  color: ", ";\n  font-weight: 500;\n  padding: 0.125rem 1rem 0.625rem 0;\n\n  svg {\n    width: 1rem;\n    height: 1rem;\n    margin-right: 0.125rem;\n  }\n"])), function (_a) {
    var error = _a.theme.error;
    return error.color.normal;
});
var StyledHeadline = styled_components_1.default(module_components_1.Headline)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-bottom: 0.813rem;\n"], ["\n  margin-bottom: 0.813rem;\n"])));
var AnimatedConditionContainer = styled_components_1.default(react_spring_1.animated.div)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  will-change: height;\n"], ["\n  will-change: height;\n"])));
var errorColor = function () { return theme_1.default.error.color.normal; };
var Page1 = function (stateFunctions) {
    var setPage = stateFunctions.setPage;
    var intl = react_intl_1.useIntl();
    var config = useConfig_1.default();
    var ArrowIcon = getIcon_1.default('ArrowMiniDown');
    var StopIcon = getIcon_1.default('Disadvantage');
    var _a = react_1.useState(false), stateIsConditionOpen = _a[0], setStateIsOpen = _a[1];
    var _b = react_1.useState(null), errorMessage = _b[0], setErrorMessage = _b[1];
    var isMobile = react_media_match_1.useMedia({ mobile: true, tablet: true, desktop: false });
    var _c = useMeasure_1.default(), refCondition = _c[0], contentHeight = _c[1].height;
    var _d = useMeasure_1.default(), refConditionHead = _d[0], contentHeadHeight = _d[1].height;
    var animatedConditionHeight = react_spring_1.useSpring({
        config: { tension: 210, friction: 40 },
        height: stateIsConditionOpen ? contentHeight + contentHeadHeight : 0,
    }).height;
    function onHeadClick() {
        setStateIsOpen(function (isContentOpen) { return !isContentOpen; });
    }
    return (react_1.default.createElement(StyledPageContent, null,
        !isMobile && (react_1.default.createElement(StyledHeadline, { level: 5, element: "div" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.genInfoHeadline", defaultMessage: "{content}" }))),
        react_1.default.createElement(StyledFormWrapper, { hasError: !!errorMessage },
            react_1.default.createElement("form", { "data-testid": "subscribeForm", noValidate: true },
                react_1.default.createElement("input", { id: "newsletterEmail", type: "email", placeholder: intl.formatMessage(newsletterSheetTextsPage1.emailPlaceholder), required: true }),
                react_1.default.createElement(module_components_1.Button, { layout: "primary", size: "large", onClick: function (event) {
                        return submitRegisterForm_1.default({ setPage: setPage, setErrorMessage: setErrorMessage }, intl, config, event);
                    } }, isMobile ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.regBtnMob", defaultMessage: "{content}" })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.regBtn", defaultMessage: "{content}" }))))),
        errorMessage && (react_1.default.createElement(StyledErrorMessage, { "data-testid": "errorMessage" },
            react_1.default.createElement(StopIcon, { color: errorColor() }),
            errorMessage)),
        react_1.default.createElement("div", { style: { margin: '0.5rem 0 0.8rem 0' }, 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: intl.formatMessage(newsletterSheetTextsPage1.generalInformationText),
            } }),
        // exclude voucher condition if there is no corresponding setting in tenant-config
        intl.formatMessage(newsletterSheetTextsPage1.voucherCondition) !== 'false' ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: refConditionHead },
                react_1.default.createElement(ConditionHead, { "data-testid": "conditionHead", onClick: onHeadClick, isOpen: stateIsConditionOpen },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.voucherCondition", defaultMessage: "{content}" }),
                    react_1.default.createElement(ArrowIcon, null))),
            react_1.default.createElement(AnimatedConditionContainer, { style: { height: animatedConditionHeight } },
                react_1.default.createElement("div", { ref: refCondition },
                    ' ',
                    react_1.default.createElement(ConditionBody, { "data-testid": "conditionContent" },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.voucherConditionContent", defaultMessage: "{content}" })))))) : (
        // bottom margin if there is no voucher condition
        react_1.default.createElement("div", { style: { height: '1.5rem' } }))));
};
exports.default = Page1;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Page1.js.map